'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Event handlers used by Slate plugins.
 *
 * @type {Array}
 */

var EVENT_HANDLERS = ['onBeforeInput', 'onBlur', 'onClick', 'onCompositionEnd', 'onCompositionStart', 'onCopy', 'onCut', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onInput', 'onFocus', 'onKeyDown', 'onKeyUp', 'onPaste', 'onSelect'];

/**
 * Export.
 *
 * @type {Array}
 */

exports.default = EVENT_HANDLERS;


//////////////////
// WEBPACK FOOTER
// ../node_modules/slate-react/lib/constants/event-handlers.js
// module id = 157
// module chunks = 0